export default {
  config: {
    location: 'Staðsetning',
    terminalId: 'POI nafn',
    save: 'Vista',
  },
  location: {
    HENGIFOSS: 'Hengifoss',
    SELJALANDSFOSS: 'Seljalandsfoss',
    SELIR: 'Selaströnd',
    THINGVELLIR: 'Þingvellir',
  },
  types: {
    A: {
      title: 'Bifhjól',
      passengers: '1-2 farþegar',
      name: 'Bifhjól / 1-2 farþegar / {price}',
    },
    B: {
      title: 'Einkabifreið',
      passengers: '1-5 farþegar',
      name: 'Einkabifreið / 1-5 farþegar / {price}',
    },
    C: {
      title: 'Stærri einkabifreið',
      passengers: '6-9 farþegar',
      name: 'Stærri einkabifreið / 6-9 farþegar / {price}',
    },
    D: {
      title: 'Minni rúta',
      passengers: '10-19 farþegar',
      name: 'Minni rúta / 10-19 farþegar / {price}',
    },
    E: {
      title: 'Rúta',
      passengers: '20-32 farþegar og yfir',
      name: 'Rúta / 20-32 farþegar / {price}',
    },
    F: {
      title: 'Stærri rúta',
      passengers: '33 farþegar og yfir',
      name: 'Stærri rúta / 33 farþegar og yfir / {price}',
    },
  },
  instructions: {
    title: 'Þegar ekið er inn og út af bílastæðinu er bílnúmer ökutækis lesið og það borið saman við greiðslur á þjónustugjaldi.',
    step1: 'Veldu stærð ökutækis',
    step2: 'Sláðu inn bílnúmer ökutækis',
    step3: 'Sláðu inn netfang, ef þú vilt fá kvittun (valkvætt)',
    note: 'Engin þörf er á að þú setjir prentaðan miða í glugga ökutækis',
    example: 'Dæmi um númeraplötu á ökutæki',
    plate: 'ABC12',
    more: 'More information',
    website: 'Ef þú vilt frekar borga á vefnum getur þú farið á www.checkit.is eða skannað QR kóðann.',
  },
  complete: {
    thankYou: 'Takk fyrir',
    success: 'Greiðsla tókst fyrir ökutæki',
    total: 'Upphæð',
    receipt: 'Kvittun var send á netfangið:',
    reset: 'Borga fyrir annað stæði',
  },
  dialogs: {
    plate: {
      title: 'Sláðu inn bílnúmer',
      licencePlate: 'Númeraplata ökutækis',
      email: 'Netfang, ef þú vilt fá senda kvittun',
      continue: 'Áfram',
      cancel: 'Hætta við',
    },
    pos: {
      title: 'Greiðsla',
      insert: 'Þú getur núna greitt með posanum',
      cancel: 'ATH: Til að hætta við þarf að ýta á "Hætta við" takkann á posanum',
    },
    wait: {
      title: 'Augnablik',
      message: 'Verið er að ganga frá greiðslu',
    },
  },
  errors: {
    default: {
      title: 'Villa',
      message: 'Keyrsla skilaði villu: "{error}"',
    },
    networkError: {
      title: 'Sambandsrof',
      message: 'Ekki náðist samband við þjónustur.',
    },
    poiTimedOut: {
      title: 'Villa',
      message: 'Engin greiðsla barst.',
    },
    poiStatus: {
      title: 'Villa',
      message: 'Gat ekki sótt stöðu á greiðslu',
    },
    poiBusy: {
      title: 'Villa',
      message: 'Greiðsluvél er upptekin, reyndu aftur síðar',
    },
    poiRefusal: {
      title: 'Villa',
      message: 'Neitun um greiðslu',
    },
    poiUnavailable: {
      title: 'Villa',
      message: 'Samband náðist ekki við posa, reyndu aftur síðar',
    },
    poiDisconnected: {
      title: 'Villa',
      message: 'Ekki náðist samband við greiðsluvél',
    },
    poiError: {
      title: 'Villa',
      message: 'Villa barst frá greiðsluvél',
    },
    transactionAborted: {
      title: 'Hætt við greiðslu',
      message: 'Notandi hætti við greiðslu á greiðsluvél',
    },
    licencePlate: {
      noInput: 'Númeraplata verður að vera að minnsta kosti 2 stafir',
      noVisit: 'Númeraplata hefur enga skráða heimsókn. Er hún rétt skráð?',
      invalidEmail: 'Gildi er ekki gilt netfang',
    },
    pos: {
      busy: {
        title: 'Villa í samskiptum við posa',
        message: 'Missti samband við posann.',
        ok: 'Reyna aftur',
      },
      cancelled: {
        title: 'Skilaboð frá posa',
        message: 'Notandi hætti við.',
        ok: 'Reyna aftur',
      },
      error: {
        title: 'Villa frá posa',
        message: 'Posi skilaði eftirfarandi villu: {error}',
        ok: 'Reyna aftur',
      },
    },
  },
  ux: {
    A: 'Borgaðu með posanum',
    R: 'Fjarlægðu kortið',
    0: 'Borgaðu með posanum',
    9: 'Kort lesið',
    8: 'Greiðsla heimiluð',
    7: 'Sláðu inn PIN',
    cancel: 'Hætt við greiðslu',
    declined: 'Greiðslu var hafnað',
    timeout: 'Aðgerð rann út á tíma',
    amountToLarge: 'Upphæð of há',
    amountToLargeForNFC: 'Upphæð of há fyrir snertilausa greiðslu',
    posError: 'Villa frá posa',
    terminalNotConnected: 'Enginn posi tengdur. Hætt við greiðslu',
    terminalDisconnected: 'Missti samband við posa. Hætt við greiðslu',
  },
};
